import Backbone from 'backbone';
import Constants from 'root/constants';

var Referral_Invoice = Backbone.Model.extend({
    defaults: {
        account_id             : 0,
        amount                 : 0,
        status                 : Constants.UNPAID,
        type                   : '',
        paid_time              : 0,
        paypal_email           : '',
        paypal_payout_batch_id : '',
        description            : '',
        statement_description  : ''
    }
});

export default Referral_Invoice;